import { render, staticRenderFns } from "./myCollapse.vue?vue&type=template&id=7ca2d762&scoped=true"
import script from "./myCollapse.vue?vue&type=script&lang=ts"
export * from "./myCollapse.vue?vue&type=script&lang=ts"
import style0 from "./myCollapse.vue?vue&type=style&index=0&id=7ca2d762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca2d762",
  null
  
)

export default component.exports